/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Forbidden_ScopeInputs */

const vi_error_forbidden_scope = /** @type {(inputs: Error_Forbidden_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoá API này không được phép gọi chức năng này (sai loại khoá: đối tác hay web bán hàng).`)
};

/**

* @param {Error_Forbidden_ScopeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_forbidden_scope = /** @type {((inputs?: Error_Forbidden_ScopeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Forbidden_ScopeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_forbidden_scope(inputs)
});